<template>
  <div>
    <collapse :active-index="0">
      <collapse-item>
        <template slot="title">
          <div class="row">
            <div class="col">
              <h3 class="mb-0">Precipitaciones</h3>
            </div>

            <div class="col text-right pr-5"></div>
          </div>
        </template>
        <ul v-if="rainMeasures && rainMeasures.length !== 0" class="list-group list-group-flush list my--3">
          <li v-for="rain in rainMeasures" :key="rain.id" class="list-group-item px-0">
            <div class="row align-items-center">
              <div class="col-sm-3">
                <p class="h5 mb-0">Fecha</p>
                <div class="medium mb-2">{{ rain.date | date }}</div>
              </div>
              <div class="col-sm-6">
                <div v-if="rain.quantity">
                  <p class="h5 mb-0">Descripción</p>
                  <div class="medium mb-2">{{ rain.description }}</div>
                </div>
              </div>
              <div class="col-sm-2 text-right">
                <div v-if="rain.quantity">
                  <p class="h5 mb-0 pr-3">Milímetros</p>
                  <div class="medium mb-2 pr-3">{{ rain.quantity }}</div>
                </div>
              </div>
              <div v-if="$can('destroy', 'rain_measures') && canDelete" class="col-sm-1">
                <button class="btn base-button btn-outline-danger btn-sm" @click="deleteRain(rain.id)">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
          </li>
          <li class="list-group-item px-0">
            <div class="row">
              <div class="col-sm-11 text-right">
                <p class="h5 mb-0 pr-3">Total de Milimetros</p>
                <div class="medium mb-2 pr-3">{{ totalQuantity }}</div>
              </div>
            </div>
          </li>
        </ul>
        <ul v-else class="list-group list-group-flush list my--3">
          <li class="list-group-item px-0">
            <div class="row align-items-center">
              <div class="col">
                <h4 class="mb-0">Este Lote no posee precipitaciones registradas</h4>
              </div>
            </div>
          </li>
        </ul>
      </collapse-item>
    </collapse>
  </div>
</template>

<script>
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';
import swal from 'sweetalert2';

export default {
  components: {
    Collapse,
    CollapseItem,
  },

  props: {
    rainMeasures: {
      type: Array,
      default: () => [],
    },

    canDelete: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      collapsed: -1,
    };
  },

  computed: {
    totalQuantity() {
      return this.rainMeasures.reduce((acum, rain) => acum + Number(rain.quantity), 0);
    },
  },

  created() {},
  methods: {
    deleteRain(rainId) {
      swal({
        title: `Va a eliminar una precipitación!`,
        text: `¿Está seguro que desea continuar?`,
        buttonsStyling: false,
        confirmButtonText: `Eliminar`,
        confirmButtonClass: 'btn btn-danger',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: `Cancelar`,
        cancelButtonClass: 'btn btn-success',
      }).then((result) => {
        if (result.value) {
          this.$emit('delete', rainId);
        }
      });
    },
  },
};
</script>
